import { render } from "./gaji-list-pisah-updated.vue?vue&type=template&id=230a7108"
import script from "./gaji-list-pisah-updated.vue?vue&type=script&lang=js"
export * from "./gaji-list-pisah-updated.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__